module.exports = __webpack_public_path__ + "static/media/writing.61ae9453.svg";